import { GetActivityLogsState } from 'store/reducers/activity-log/get-activity-logs/types';
import { GetUserActivityLogsActionTypes, GET_USER_ACTIVITY_LOGS_FAILURE, GET_USER_ACTIVITY_LOGS_REQUEST, GET_USER_ACTIVITY_LOGS_SUCCESS } from './types';

const defaultState: GetActivityLogsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getUserActivityLogs(state = defaultState, action: GetUserActivityLogsActionTypes): GetActivityLogsState {
  switch (action.type) {
    case GET_USER_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_USER_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_USER_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};